//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import './FormNivel4.css';
import { PRINCIPAL, NAVBARS, COLOR_BTN, COLOR_BOTONES } from '../../constants/colors';

//Contextos
import nivel4Context from '../../context/nivel4Context/nivel4Context';
import activoContext from '../../context/activoContex/activoContex';
import { estructuraNivel1, estructuraNivel3 } from '../../utils/estructuras';
import DictionaryText from '../dictionaryText/DictionaryText';
import authContext from '../../context/authentication/authContex';
import clienteAxios from '../../config/axios';

/*
    Componente encargado de mostrar el formulario de usuario.
        Donde data es el usuario crear/modificar.
              minimizar es la función encargada de ocultar el dialogo.
              generar es la función del context que guarda el usuario.
              titulo es la que determina que texto mostrar en encabezado del dialogo.
              verficaUser es la función del context que comprueba la licencia por usuario vigente del cliente.
*/
function FormNivel4({ data,setData, minimizar, formDato, nuevoEditado, i, handleChangeUbicaciones, generar = () => console.log("Generando"), listaUsuarios = [], optionsNivel3, nivel3Lista, nivel3Seleccionado, modo }) {
    
    // context agregarActivo - modificarrActivo
    const {actualizaractivoList} = useContext(activoContext)

    const pContext = useContext(nivel4Context);
    const {agregarNivel4, actualizarNivel4List, modificarNivel4, eliminarNivel4} = pContext;

    //State de usuario. Si no viene data por parametro significa que es nuevo por lo que se le asigna una estructura.
    const [nivel4, setNivel4] = useState((data !== undefined && nuevoEditado == 'Modificar') ? {group: {codNivel4:data?.codNivel4, name: data?.name, descrp:data?.descrp, codNivel3: nivel3Seleccionado?.codNivel3, id: data?.id, direccion: data?.direccion || '', lat: data?.lat || null, lng: data?.lng || null}} : {group: {codNivel4:"", name:"", descrp:"",codNivel3: nivel3Seleccionado.codNivel3, direccion: '', lat: null, lng: null}, members: []});
    const [opcionSeleccionada, setOpcionSeleccionada] = useState(null);

    const {getValorActualFromDictionary} = useContext(authContext);

    //nivel3Seleccionado tengo que agregarle el value y el label para que se vean.
    const nivel3SeleccionadoNormalizada = {
        value: nivel3Seleccionado?.name || nivel3Seleccionado?.label,
        label: nivel3Seleccionado?.name || nivel3Seleccionado?.label,
        // Resto de las propiedades que quieras copiar
        codNivel3: nivel3Seleccionado?.codNivel3,
        descrp: nivel3Seleccionado?.descrp,
        id: nivel3Seleccionado?.id,
        
    };

    const nivel3SeleccionadoValue = nivel3Seleccionado?.value !== undefined ? 
                  {...nivel3Seleccionado, value: nivel3Seleccionado.name, label: nivel3Seleccionado.name } 
                  : nivel3Seleccionado

    //Constante que define el titulo que corresponde si vienen datos por parametros
    const [titulo, setTitulo] = useState(nuevoEditado)
   
    //Funcion de validacion
    const validacion =  () => { 
        const newErrors = {};

        if (nivel4.group.codNivel4 === '' || nivel4.group.codNivel4 === undefined) return newErrors.codigo = 'El código debe ser colocado';
        if (nivel4.group.name === '' || nivel4.group.codNivel4 === undefined) return newErrors.nombre = 'El nombre debe ser colocado';
        if (nivel4.group.descrp === '' || nivel4.group.descrp === undefined) return newErrors.nombre = 'La descripción debe ser colocada';

        return '';    
    };

    const handleGeocodificar = async () => {
        try {
            const resp = await clienteAxios.get(`/geocode?address=${encodeURIComponent(nivel4.group.direccion)}`);
            const { lat, lng } = resp.data.data;
            setNivel4({ ...nivel4, group: { ...nivel4.group, lat, lng } });
        } catch (err) {
            Swal.fire({ icon: 'warning', title: 'No se pudo geocodificar',
                text: err.response?.data?.message || 'Verifique la direccion ingresada' });
        }
    };

    // manda los datos al back
    const handlerGenerar = async () => {

        const errorAxi = validacion();

        if (errorAxi === "" ) {

            try {

                const { group } = nivel4;

                // Crea un nuevo objeto sin la propiedad id
                const { id, ...datoSinId } = group;
                //compara el name del Select con el name de la la DB para mandar info a la DB
                const filtro = nivel3Lista?.filter(dato => dato?._id === nivel3SeleccionadoValue?.id);
                const nivel4Nivel3 = filtro[0]

                const datos = {...datoSinId, nivel4Nivel3}

                const res = await agregarNivel4(datos)
                console.log("res");
                console.log(res);
                if (res !== null) {
                    Swal.fire({
                        title: `Guardado exitosamente!`,
                        icon: 'success',
                        text: `Código: ${res.lv4Saved.codNivel4} \n Nombre: ${res.lv4Saved.name} `,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizaractivoList();
                    actualizarNivel4List();
                    minimizar();
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }
    }

    const handlerModificar = async () => {
        const errorAxi = validacion();

        if (errorAxi === "") {
    
            try {
                const dato = {
                    id: nivel4.group.id === undefined ? data._id : nivel4.group.id,
                    codNivel4: nivel4.group.codNivel4,
                    codNivel3:nivel4.group.codNivel3,
                    name: nivel4.group.name,
                    descrp: nivel4.group.descrp,
                    direccion: nivel4.group.direccion,
                    lat: nivel4.group.lat,
                    lng: nivel4.group.lng
                }

                const res = await modificarNivel4(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Modificado exitosamente!`,
                        icon: 'success',
                        text: `Código: ${res.codNivel4} \n Nombre: ${res.name} `,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarNivel4List();
                    actualizaractivoList();
                    minimizar({...dato, label: res.name, value: res.name});
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }  
    }

    //lee lo que esta en el Select
    const handleChange = (selectedOption) => {
        setOpcionSeleccionada(selectedOption);
    }

    const handlerEliminar = () => {
        const dato = {
            id: data.id,
            codNivel3:nivel4.group.codNivel3,
            name: nivel4.group.name,
            descrp: nivel4.group.descrp 
        }

        Swal.fire({
            title: `Estas seguro que deseas eliminar ${data.name}?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true, // Habilita el botón de cancelar
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
              // El usuario hizo clic en "Aceptar"
                const id = data.id
                const resp = await eliminarNivel4(id);

                if(resp === "No se puede borrar la nivel4 porque contiene un Nivel3s") {
                    Swal.fire({
                        title: `No puede eliminarse!`,
                        icon: 'warning',
                        text: `Para poder eliminar no tiene que tener ${getValorActualFromDictionary("Nivel3")}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                        
                    })
                    minimizar({...dato, label: dato.name, value:dato.name});
                }else{
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `Eliminado correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    actualizaractivoList();
                    actualizarNivel4List();
                    minimizar(null);
                    handleChangeUbicaciones({},i,'nivel4',{...estructuraNivel1})
                }
            } else if (result.isDismissed) {
             // El usuario hizo clic en "Cancelar" o en cualquier otro lugar fuera del diálogo
                 minimizar({...dato, label: dato.name, value:dato.name});
            }
            });
    }

    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}} >
                {titulo} <DictionaryText text={"Nivel4"}/>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Codigo de <DictionaryText text={"Nivel4"}/>: </div>
                <input disabled={ titulo === "Modificar"} value={nivel4.group.codNivel4} className='label-form-group-data' onChange={data => setNivel4({ ...nivel4, group: {...nivel4.group, codNivel4: data.target.value} })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={nivel4.group.name} className='label-form-group-data' onChange={data => setNivel4({ ...nivel4, group: {...nivel4.group, name: data.target.value} })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Descripción: </div>
                <textarea className='label-form-group-data' value={nivel4.group.descrp} onChange={data => setNivel4({ ...nivel4, group: {...nivel4.group, descrp: data.target.value} })}/>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Direccion (opcional): </div>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                    <input
                        value={nivel4.group.direccion || ''}
                        className='label-form-group-data'
                        style={{ flex: 1 }}
                        placeholder="Ej: Av. Corrientes 1234, CABA"
                        onChange={e => setNivel4({...nivel4, group: {...nivel4.group, direccion: e.target.value, lat: null, lng: null}})}
                    />
                    {nivel4.group.direccion && !nivel4.group.lat && (
                        <button type="button" className="geocodeBtnOPD" onClick={handleGeocodificar}>Validar</button>
                    )}
                    {nivel4.group.lat && <span style={{ color: 'green', fontSize: '0.8rem' }}>&#10003; Validada</span>}
                </div>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nivel3: </div>
                <Select
                    styles={{
                        input: (base) => ({
                            ...base,
                            width: "100%",
                            padding: ".4rem",
                            borderRadius: ".5rem",
                            fontSize: "1rem",
                            transition: "border-color .5s"
                        })
                    }}
                    isDisabled={true}
                    placeholder="Elija el nivel3 que corresponda..."
                    options={optionsNivel3}
                    value={nivel3SeleccionadoNormalizada}
                    onChange={handleChange}
                    
                />
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={( titulo !== "Modificar") ? handlerGenerar : handlerModificar}>{titulo}</button>
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )

                }
                {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(formDato.activoNivel4)}>Cancelar</button>
                    )
                }
            </div>
        </div>
    );
}

export default FormNivel4;